import api from "../utils/api";
import {
  GET_PROFILE_DATA, LOGOUT
} from "./types";

export const get = (url) => async (dispatch) => {
    try {
        const res = await api.get(`/settings/licensee?u=${url}`);
        dispatch({
            type: GET_PROFILE_DATA,
            payload: res.data,
        });
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
};
